module.exports = __webpack_public_path__ + "static/media/green_dots@3x.4e5c340f.png";